import React from "react";
import { Button } from "@mui/material";
import AddCommentOutlinedIcon from "@mui/icons-material/AddCommentOutlined";

const AddButton = ({
  label,
  color = "primary",
  variant = "contained",
  startIcon = <AddCommentOutlinedIcon />,
  onClick,
  disabled = false,
  sx = {},
  ...props
}) => {
  return (
    <Button
      color={color}
      variant={variant}
      onClick={onClick}
      startIcon={startIcon}
      disabled={disabled}
      {...props}
      sx={{ pt: 1, pb: 1, pl: 4, pr: 4, borderRadius: 8, background: 'linear-gradient(90deg, rgba(62,142,255,1) 0%, rgba(36,93,173,1) 35%)',...sx }}
    >
      {label}
    </Button>
  );
};

export default AddButton;
